




























































































































































import moment from "moment";
import { Mixins } from "vue-mixin-decorator";
import { Component, Prop } from "vue-property-decorator";
import { Action, Mutation, Getter } from "vuex-class";
import GeneralMixin from "@/mixin";
import { ISelectItem } from "@/types";
import { ISite, ISiteCreateRequest, ISiteUpdateRequest } from "@/types/site";
import { IUser, IUserListRequest } from "@/types/user";
import { IStaff, IStaffListRequest } from "@/types/staff";
import { IContractorListRequest } from "@/types/contractor";

@Component({
  components: {}
})
export default class extends Mixins<GeneralMixin>(GeneralMixin) {
  @Action("site/adminGet")
  public getSite!: (id: number) => void;

  @Action("site/adminCreate")
  public create!: (params: ISiteCreateRequest) => boolean;

  @Action("site/adminUpdate")
  public update!: (data: {
    site_id: number;
    params: ISiteUpdateRequest;
  }) => boolean;

  @Action("user/adminGetUserList")
  public getUsers!: (params: IUserListRequest) => boolean;

  @Action("contractor/adminGetList")
  public getContractors!: (params: IContractorListRequest) => boolean;

  @Action("staff/adminGetList")
  public getStaffList!: (params: IStaffListRequest) => boolean;

  @Getter("site/single")
  public site!: ISite;

  @Getter("user/userSelectItem")
  public userList!: ISelectItem[];

  @Getter("user/salesSelectItem")
  public salesList!: ISelectItem[];

  @Getter("contractor/selectItem")
  public contractorList!: ISelectItem[];

  @Getter("staff/selectItem")
  public staffs!: ISelectItem[];

  @Getter("staff/find")
  public staff_find!: (staff_id: number) => IStaff;

  @Getter("auth/user")
  public user!: IUser;

  @Mutation("site/clear")
  public clear!: () => void;

  @Mutation("user/clear")
  public clearUser!: () => void;

  @Mutation("contractor/clear")
  public clearContractor!: () => void;

  @Prop({ default: 0 })
  public site_id!: number;

  public valid = true;
  public lazy = false;

  public startValidation: Array<boolean | string> = [true];
  public endValidation: Array<boolean | string> = [true];

  public span_validate() {
    this.startValidation = [true];
    this.endValidation = [true];
    if (!this.params.span_start || !this.params.span_end) {
      return;
    }
    const diff = moment(this.params.span_start).diff(this.params.span_end, "d");
    if (diff > 0) {
      this.startValidation = ["開始日は終了日より前にしてください"];
      this.endValidation = ["終了日は開始日より後にしてください"];
    }
  }

  public rules = {
    name: [
      (v: string) => !!v || "現場名は必須です",
      (v: string) =>
        (v && v.length <= 30) || "現場名は30文字以下で入力してください"
    ],
    address: [
      (v: string) => !!v || "住所は必須です",
      (v: string) =>
        (v && v.length <= 191) || "住所は191文字以下で入力してください"
    ],
    user_id: [(v: string) => !!v || "担当者は必須です"],
    // sales_id: [(v: string) => !!v || "営業担当者は必須です"],
    contractor_id: [(v: string) => !!v || "元請けは必須です"],
    staff_id: [(v: string) => !!v || "元請け担当者は必須です"]
  };

  public params: ISiteCreateRequest = {
    name: "",
    address: "",
    users: [],
    sales_id: 0,
    staff_id: 0,
    contractor_id: 0,
    span_start: "",
    span_end: "",
    is_completion: false,
    budget: undefined,
    contract_price: undefined
  };

  public menu = {
    span_start: false,
    span_end: false,
    staff: false
  };

  public async created() {
    const site_id = Number(this.$route.params.site_id);
    this.clear();
    this.clearUser();
    this.clearContractor();

    await Promise.all([
      this.getUsers({ per_page: 0 }),
      this.getContractors({ per_page: 0 })
    ]);

    // 新規作成
    if (!site_id) {
      return;
    }

    // if (!this.site_id) {
    //   this.getStaffList({ per_page: 0});
    //   return;
    // }

    // 更新
    await this.getSite(site_id);
    this.setDefault();

    // await Promise.all([
    //   this.getStaffList({ per_page: 0 }),
    //   this.getSite(site_id)

    // ])
    // this.setDefault();

    if (this.site.contractor_id) {
      await this.getStaffList({
        contractor_id: this.site.contractor_id,
        per_page: 0
      });
      if (this.staffs.length > 0) {
        this.menu.staff = true;
      }
    }
  }

  private setDefault() {
    this.params.name = this.site.name;
    this.params.address = this.site.address;
    this.params.sales_id = this.site.sales_id;
    this.params.contractor_id = this.site.contractor_id;
    this.params.staff_id = this.site.staff_id;
    this.params.contract_price = this.site.contract_price || undefined;
    this.params.budget = this.site.budget || undefined;
    this.params.span_start = this.date_format(this.site.span_start);
    this.params.span_end = this.date_format(this.site.span_end);
    this.params.is_completion = this.site.is_completion;
    if (this.site.users) {
      this.site.users.forEach(user => {
        this.params.users.push(user.id);
      });
    }
  }

  //--------
  // 元請けが選択された際、
  // 適切な選択項目を用意する
  public async contractorSelected() {
    this.params.staff_id = 0;
    this.menu.staff = false;
    await this.getStaffList({
      contractor_id: this.params.contractor_id,
      per_page: 0
    });
    this.menu.staff = true;
  }

  public clearValComp() {
    this.params.is_completion = false;
    this.span_validate();
  }
  public async submit() {
    let result = false;
    if (this.site.id) {
      result = await this.update({
        site_id: this.site.id,
        params: this.params
      });
    } else {
      result = await this.create(this.params);
    }
    if (result) {
      this.$router.go(-1);
    }
  }
}
